import { render, staticRenderFns } from "./ReleaseNotesEditor.vue?vue&type=template&id=1aa79440&scoped=true"
import script from "./ReleaseNotesEditor.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesEditor.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNotesEditor.vue?vue&type=style&index=0&id=1aa79440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa79440",
  null
  
)

export default component.exports